import { initMercadoPago, Wallet } from '@mercadopago/sdk-react'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { toastErrorLog } from '../../../helpers/toastErrorLog'

import { crearPreferencia } from '../../servicios/mercadoPagoService'

export const PasarelaMP = ({ items }) => {
  const [preferenceId, setPreferenceId] = useState(null)
  const obtenerPreferenceId = async () => {
    try {
      const { data } = await crearPreferencia(items)

      initMercadoPago(data.body.publicKey)
      setPreferenceId(data.body.id)
    } catch (error) {
      const mensaje = `Ocurrió un error al crear la preferencia de pago en Mercado Pago.`
      toastErrorLog(error, mensaje, 'mercadoPago')
    }
  }
  useEffect(() => {
    !preferenceId && obtenerPreferenceId()
  }, [preferenceId])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '50px'
      }}
    >
      {preferenceId ? (
        <div style={{ width: '300px' }}>
          <Wallet initialization={{ preferenceId }} />
        </div>
      ) : (
        <Spinner animation="border" />
      )}
    </div>
  )
}

PasarelaMP.propTypes = {
  items: PropTypes.object.isRequired
}
